import { REQUEST } from '~/middleware/ndsRequest';

export const SessionProfileActionTypes = {
  LOAD: 'loadProfile',
  LOAD_STATUS: 'loadDamStatus',
};

const requestData = (options) => ({
  [REQUEST]: options,
});

export default {
  loadSession: () => (dispatch) =>
    dispatch(
      requestData({
        type: SessionProfileActionTypes.LOAD,
        endpoint: '/rest/config',
        method: 'GET',
      }),
    ),
  loadStatus: () => (dispatch) =>
    dispatch(
      requestData({
        type: SessionProfileActionTypes.LOAD_STATUS,
        endpoint: '/rest/status',
        method: 'GET',
      }),
    ),
};



// WEBPACK FOOTER //
// ./resources/assets/js/actions/session.js